import React from "react";


import { Col } from "react-bootstrap";


import { ButtonComponent } from "@Components/Forms";


import "./index.scss";
import {UseQyvoUser} from "@Store/@Hooks";


export const AppSupportSectionButtons: React.FC = () => {


    const QyvoUser = UseQyvoUser();


    return (
        <Col xs={12} className={'app-support-section__page-bottom-section__section-content__buttons'}>
            <ButtonComponent
                text={'Contact support'}
                href={'/contact-us'}
                type={'secondary'}
                size={'l'}
            />
            {!QyvoUser &&
            <ButtonComponent
                text={'Join early access'}
                href={'/join-qyvo'}
                type={'cta'}
                size={'l'}
            />
            }
        </Col>
    );

};


export default AppSupportSectionButtons;
